<template>
  <section>
    <qx-card :title="title" class="detail" v-loading="loading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
    </qx-card>
  </section>
</template>
<script>
import {
  getVehicleCertificatesInsurance, // 获取详情
} from 'api/car';
import {
  getFileUrl,
} from 'api';
export default {
  components: {
  },
  data () {
    return {
      title: '查看证照登记',
      loading: false,
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'plateNumber',
                label: '车牌号码',
              },
              {
                prop: 'orgName',
                label: '车辆归属',
              },
              {
                prop: 'licenceTypeName',
                label: '车辆类型',
              },
              {
                prop: 'vehicleOwnerShipName',
                label: '车辆性质',
              },
              {
                prop: 'brandModelName',
                label: '品牌名称',
              },
              {
                prop: 'vehicleLengthName',
                label: '车长',
              },
              // {
              //   prop: 'horsePower',
              //   label: '马力',
              // },
              // {
              //   prop: 'bodyColor',
              //   label: '车身颜色',
              // },
              {
                prop: 'axleNumber',
                label: '轴数',
              },
              // {
              //   prop: 'tireNumberName',
              //   label: '单/双胎',
              // },
              // {
              //   prop: 'tyreType',
              //   label: '轮胎型号',
              // },
              {
                prop: 'engineNo',
                label: '发动机号',
              },
              {
                prop: 'vinNo',
                label: '车架号',
              },
              {
                prop: 'vehicleOriginName',
                label: '配置',
              },
              {
                prop: 'vehicleState',
                label: '使用状态',
              },
            ],
            data: {},
            approveData: {},
          },
        },
        info: {
          label: '登记信息',
          tableData: {
            title: [
              {
                prop: 'certificatesInsuranceTypeName',
                label: '保险类型',
              },
              {
                prop: 'certificatesInsuranceFee',
                label: '保费（元）',
              },
              {
                prop: 'insuranceStartDate',
                label: '起保日期',
              },
              {
                prop: 'insuranceEndDate',
                label: '终保日期',
              },
              {
                prop: 'insuranceCode',
                label: '保单号',
              },
              {
                prop: 'insuranceInsurant',
                label: '被保险人',
              },
              {
                prop: 'stateName',
                label: '是否退保',
              },
              {
                prop: 'insuranceTerminationDate',
                label: '退保时间',
              },
              {
                prop: 'backInsuranceFee',
                label: '退保费',
              },
              {
                prop: 'serviceName',
                label: '保险公司',
              },
              // {
              //   prop: 'picList',
              //   label: '证件图片',
              // },
            ],
            data: {},
            approveData: {},
          },
        },
      },
    };
  },
  watch: {
    '$route.query.id': function () {
      // 监听id来刷新页面，因为会出现多个查看详情的tab，用的都是同一个页面，所以需要监听id来回请求获取当前id的数据
      this.getData();
    },
  },
  methods: {
    async getData () {
      // 遇到这两个URL就阻止页面刷新
      if (this.$route.path !== '/manage/car/maintain/insurance/detail') {
        return;
      }
      this.loading = true;
      const detailRes = await getVehicleCertificatesInsurance({
        id: this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        // 重置一下展示的字段长度，防止来回切换 tab 的时候图片字段不断增多
        this.detailData.info.tableData.title.length = 10;
        // 获取图片 id 然后去请求另外一个接口获取图片url地址
        if (detailRes.picList && detailRes.picList.length) {

          let flowIds = [];
          for (let i = 0; i < detailRes.picList.length; i++) {
            // 判断是否是pdf文件，是pdf文件就打开超链接
            if (detailRes.picList[i].fileUrl.substring(detailRes.picList[i].fileUrl.lastIndexOf('.') + 1) === 'pdf') {
              flowIds.push(detailRes.picList[i].fileId);
              this.detailData.info.tableData.title.push({
                prop: 'pic' + i,
                label: '保单附件' + (i + 1),
                fileName: detailRes.picList[i].fileName,
                type: 'imgFile',
              });
            } else {
              flowIds.push(detailRes.picList[i].fileId);
              this.detailData.info.tableData.title.push({
                prop: 'pic' + i,
                label: '保单附件' + (i + 1),
                type: 'img',
              });
            }
          }

          const imgRes = await getFileUrl({
            flowIds: flowIds.join(),
          });

          for (let i = 0; i < detailRes.picList.length; i++) {
            imgRes.items.forEach((item) => {
              if (item.flowId === detailRes.picList[i].fileId) {
                detailRes['pic' + i] = item.fullPath;
              }
            });
          }
        } else {
          this.detailData.info.tableData.title.push({
            prop: 'pic',
            label: '保单附件',
            type: 'img',
          });
        }

        // 处理数据
        this.detailData.base.tableData.data = detailRes.vehicle || {};
        if (detailRes.state) {
          if (detailRes.state === 1) {
            detailRes.stateName = '否';
          } else if (detailRes.state === 2) {
            detailRes.stateName = '是';
          } else {
            detailRes.stateName = '未选择';
          }
        }
        if (!detailRes.certificatesInsuranceTypeName) {
          const map = {
            0: '资产险',
            3: '交强险',
            4: '商业险',
            5: '其他险',
          };
          detailRes.certificatesInsuranceTypeName = map[detailRes.certificatesInsuranceType];
        }
        this.detailData.info.tableData.data = detailRes;
      }
    },
    // async sub (formData) {
    // },
  },
  mounted () {
    this.getData();
  },
};
</script>
<style>
</style>
